import isEqual from 'lodash/isEqual'

import { MobxRestCache } from './mobx-rest'

const data = new Map<string, { params: object; value: unknown }>()

const cache: MobxRestCache = {
  identify: <T extends { constructor: { name: string } }>(collection: T) => {
    return collection.constructor.name.toLowerCase()
  },
  read: <T>(path: string, params: object) => {
    const cached = data.get(path)

    if (!cached) return null

    if (!isEqual(params, cached.params)) return null

    return cached.value as T
  },
  write: <T>(path: string, params: object, value: T) => {
    data.set(path, { params, value })
  },
  evict: (path: string) => {
    data.delete(path)
  },
}

export default cache
